<template>
  <div class="modal fade" id="constructionTemplateModal" tabindex="-1" aria-labelledby="constructionTemplateModal" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Vorlage speichern</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form v-on:submit.prevent="setSelectedTemplate">
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <select class="form-control mb-2 w-100" id="ctemp" v-model="selectedTemplate" required>
                  <option value="" disabled>Vorlage wahlen</option>
                  <option v-for="(temp, index) in templates" :key="index" :value="temp" v-if="temp.name">
                    {{ temp.name }}
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="dokubtns text-right border-0">
            <span class="btninner">
              <button type="button" class="btn btn-red" data-dismiss="modal">
                Abbrechen
              </button>
              <button type="submit" class="btn btn-blue">
                Einfügen
              </button>
            </span>
          </div>
        </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      selectedTemplate: '',
    }
  },
  computed: {
    templates () {
      return this.$store.state.appSettings.constructionTemplates
    },
    project () {
      return this.$store.state.appSettings.project
    }
  },

  methods: {
    setSelectedTemplate () {
      this.project.shifts = this.selectedTemplate.shifts
      this.$store.commit("setFieldsGroups",this.selectedTemplate.groups)
      $('#constructionTemplateModal').modal('toggle');
      this.$toast.success('Vorlage erfolgreich implementiert');
    }
  }
}
</script>

<style scoped>
#constructionTemplateModal .modal-dialog {
  max-width: 30%;
}

#templateModal select, #templateModal input {
  font-size: 1.04rem;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/ConstructionTemplatesModal.vue